<template>
    <div class="ma-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'complaints/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="fetchAll()"
        >
			{{ $T('Complaints.delete-message') }}
		</v-delete-dialog>

        <!-- dialog add covenant -->
        <v-dialog
			v-model="dialog"
			max-width="500px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
                    {{ $T('Complaints.adding-complaint') }}
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="6">
							<v-autocomplete
								v-model="complainant"
                                :items="employees"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								:label="$t('inputs.complainant')"
								hide-details 
                            />
						</v-col>
                        <v-col cols="6">
							<v-autocomplete
								v-model="defendant"
                                :items="employees"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								:label="$t('inputs.defendant')"
								hide-details 
                            />
						</v-col>
                        <v-col>
                            <bee-date-input
                                v-model="dateOfComplaint"
                                :label="$T('inputs.date-of-complaint')"
                                hide-details
                                dense
                                prepend-icon="$calendar"
                                user-menu-picker
                            ></bee-date-input>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field 
                                v-model="contentOfTheComplaint"
                                outlined
								dense
								:label="$t('inputs.content-of-the-complaint')"
								hide-details 
                            />
                        </v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding || !contentOfTheComplaint || !defendant || !complainant"
						:loading="loadingAdding"
						@click="createOrEdit">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-spacer />
        <v-btn @click="dialog = true" class="mb-2" color="success" small>
            <v-icon small class="me-1"> $add </v-icon>
            {{ $t('add') }}
        </v-btn>
        <bee-handy-table 
            :items="items"
            :headers="headers"
            dense
            zebra
            hide-default-footer
            :items-per-page="-1"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                    <v-btn
                    	icon
                    	small
                    	color="edit-color"
                        @click="itemId = item.id; dialog = true"
                    >
                        <v-icon>$edit</v-icon>
                    </v-btn>
             
                    <v-btn 
                        @click="
                            itemId = item.id
                            deleteDialog = true
                        " 
                        icon 
                        small 
                        color="alert"
                    >
                        <v-icon>$delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    watch: {
        dialog(val) {
            if(val && this.itemId) {
                // this.complainant = 
                // this.defendant = 
                // this.dateOfComplaint =
                // this.contentOfTheComplaint =
          
            } else {
                this.complainant = null
                this.defendant = null
                this.dateOfComplaint = moment().format('YYYY-MM-DD')
                this.contentOfTheComplaint = null
                this.itemId = null
            }
        }
    },
    data () {
        return {
            loadingAdding: false,
            items: [],
            headers: [
                {
                    text: '#',
                    name: '',
                    value: ''
                },
                {
                    text: this.$t('headers.complainant'),
                    name: '',
                    value: ''
                },
                {
                    text: this.$t('headers.defendant'),
                    name: '',
                    value: ''
                },
                {
                    text: this.$t('headers.date-of-complaint'),   
                    name: '',
                    value: ''
                },
                {
                    text: this.$t('headers.content-of-the-complaint'),   
                    name: '',
                    value: ''
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ],
            dialog: false,
            contentOfTheComplaint: null,
            defendant: null, 
            complainant: null,
            dateOfComplaint: moment().format('YYYY-MM-DD'),
            itemId: null,
            deleteDialog: false
        }
    },

    computed: {
        ...mapState({
            employees: (state) => state.employee.employees
        })
    },

    methods: {
        moment,
        fetchAll() {},
        createOrEdit() {

        }
    },

    created () {
        Promise.all([
            // items from emerald
            this.$store.dispatch('')
        ]).then(() => {
            this.fetchAll()
        })
       
    }
}
</script>
